export default __webpack_public_path__ + "static/media/youtube-icon.5b1655f1.svg";